<p>testcomponent works!</p>
<button (click)="auth.signOut()">Logout</button>
<button (click)="testButton()">Test</button>
<button (click)="testGapi()">Get G Cals</button>
<app-asuvi-checkbox> Test Label </app-asuvi-checkbox>
